export class AppMenuItem {
    name = "";
    permissionName = "";
    icon = "";
    route = "";
    items: AppMenuItem[];
    forParent: boolean = false;
    /** Top-level items only: localization key of the sidebar section heading the item belongs to. */
    section: string = null;
    constructor(
        name: string,
        permissionName: string,
        icon: string,
        route: string,
        items?: AppMenuItem[],
        forParent: boolean = false
    ) {
        this.name = name;
        this.permissionName = permissionName;
        this.icon = icon;
        this.route = route;
        this.forParent = forParent;
        if (items === undefined) {
            this.items = [];
        } else {
            this.items = items;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/layout/nav/app-menu-item.ts